var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-clipboard-list",
    style: {
      color: "rgb(79, 52, 35)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    x: 8,
    y: 2,
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtask);
export default __webpack_public_path__ + "static/media/subtask.a2e25b7289a51fda904c5d8b413d35aa.svg";
export { ForwardRef as ReactComponent };